import {
    SET_LANGUAGE,
    SET_PAGE,
    UPDATE_PAGE,
    SET_MODULEDATA,
    HANDLE_GLOBAL_LNG_DATA,
    HANDLE_MODULE_LNG_DATA
} from '../mutation-types';
import { localLanguage } from '@/globalization/localData';
import { defaultLngCode } from '@/globalization/constant.js';

const isArray_Object = function (value) {
    return (
        Object.prototype.toString.call(value) == '[object Object]' ||
        Array.isArray(value)
    );
};
const isEmptyObject = function (value) {
    Object.keys(value).length <= 0;
};

function mergeData(to, from, getSysLanguageCb) {
    let keys = Object.keys(from);
    let key,
        len = keys.length;
    for (let i = 0; i < len; i++) {
        key = keys[i];
        let toVal = to[key];
        let fromVal = getSysLanguageCb(toVal, from[key]);
        let fromValIsObj = isArray_Object(fromVal);
        let toValIsObj = isArray_Object(toVal);
        if (fromValIsObj && toValIsObj) {
            mergeData(toVal, fromVal, getSysLanguageCb);
            continue;
        }
        if (fromVal == undefined) {
            continue;
        }
        if (toValIsObj && !fromValIsObj) {
            console.info('Language mixing will affect the data structure');
        }
        to[key] = from[key];
    }
}

const fetcherSysLanguageModules = {
    'md-footer': true,
    'md-header': true
};

function mergeLanguageToData(name, data, language, lng) {
    // if (!lng) {
    //     lng = globalization.lng();
    // }
    if (fetcherSysLanguageModules[name]) {
        mergeLanguageToData_fetcher(data, language, lng);
    } else {
        mergeLanguageToData_data(data, language, lng);
    }
    return data;
}
//国际化数据全部都在与data平级的sysLanguage中
function mergeLanguageToData_data(data, language, lng) {
    if (!language || !Object.keys(language).length) {
        return;
    }
    let languageObj = language[lng];
    if (!languageObj) {
        //如果没有language属性
        languageObj = language[defaultLngCode];
    }
    if (!languageObj) {
        return;
    }
    mergeData(data, languageObj, (_, fromVal) => fromVal);
}
//国际化数据部分存储在data中

function mergeLanguageToData_fetcher(data, language, lng) {
    const mergeLanguage = fullSysLanguage => {
        let languageObj =
            fullSysLanguage[lng] ?? fullSysLanguage[defaultLngCode];
        if (languageObj && !isEmptyObject(languageObj)) {
            mergeData(data, languageObj, (_, fromVal) => fromVal);
        }
    };
    if (language && !isEmptyObject(language)) {
        mergeLanguage(language);
    }
    if (data.sysLanguage && !isEmptyObject(data.sysLanguage)) {
        mergeLanguage(data.sysLanguage);
    }
}

export default {
    namespaced: true,
    state: () => ({
        currentLanguage: defaultLngCode,
        page: {},
        moduleData: []
    }),
    mutations: {
        [SET_LANGUAGE](state, lang) {
            if (state.currentLanguage !== lang) {
                state.currentLanguage = lang;
                localLanguage.set(lang);
            }
        },
        [SET_PAGE](state, page) {
            state.page = page || {};
        },
        [UPDATE_PAGE](state, data) {
            Object.assign(state.page, data);
            // state.page = Object.assign({}, state.page || {}, data);
        },
        [SET_MODULEDATA](state, moduleData) {
            state.moduleData = moduleData || [];
        },
        [HANDLE_GLOBAL_LNG_DATA](state) {
            let lng = state.currentLanguage;
            for (let k in state.page) {
                const v = state.page[k];
                if (!v || !v.sysLanguage) {
                    continue;
                }
                mergeLanguageToData(null, v, v.sysLanguage, lng);
            }
        },
        [HANDLE_MODULE_LNG_DATA](state) {
            let lng = state.currentLanguage;
            state.moduleData.forEach(module => {
                if (!module.data) {
                    return;
                }
                mergeLanguageToData(
                    module.name,
                    module.data,
                    module.sysLanguage,
                    lng
                );
            });
        }
    },
    actions: {
        setLanguage({ commit, state }, lang) {
            var sysLanguageList = state.page.sysLanguageList || [];
            if (sysLanguageList.map(v => v.language).includes(lang)) {
                commit(SET_LANGUAGE, lang);
            }
        },
        setBaseonLanguage({ commit, state }) {
            var sysLanguageList = state.page.sysLanguageList || [];
            var lang = localLanguage.get();
            if (!sysLanguageList.map(v => v.language).includes(lang)) {
                lang = defaultLngCode;
            }
            commit(SET_LANGUAGE, lang);
        }
    }
};
